import type { SVGIconProps } from '@/components_deprecated/icons'
import { ShortcutSVG, ShotcutDisplay } from './components'

export interface IconShortcutDisplayProps {
  iconProps: Pick<SVGIconProps, 'icon' | 'width'>
  text: string
}

export const IconShortcutDisplay: React.FC<IconShortcutDisplayProps> = ({
  iconProps,
  text,
}) => {
  return (
    <ShotcutDisplay>
      <ShortcutSVG {...iconProps} />
      <p>{text}</p>
    </ShotcutDisplay>
  )
}
